import * as THREE from 'three';

const FLOOR_MATERIAL = new THREE.MeshStandardMaterial({
  color: '#050508',
  roughness: 0.3,
  metalness: 0.8,
  transparent: true,
  opacity: 0.4,
});

export default function ReflectiveFloor({ yPosition = -1.5 }) {
  return (
    <mesh
      rotation={[-Math.PI / 2, 0, 0]}
      position={[0, yPosition, 0]}
      material={FLOOR_MATERIAL}
    >
      <planeGeometry args={[50, 50]} />
    </mesh>
  );
}
